<template>
    <router-link :to="{ name: 'detail', params: { id: item.pk } }" class="element" :class="[
        { mobileArchive: onArchive && $mq == 'sm', first },
        item.category,
    ]">
        <div class="function first">
            <div v-show="isArchive && (item.has_audio || item.url)">
                <img v-if="isPlaying(item.pk, item.type)" @click.stop.prevent="setPause" id="pause"
                    class="button visible" :src="pauseHover
                        ? '/static/new_icons/pause-player-small_hover.svg'
                        : '/static/new_icons/pause-player-small.svg'
                        " @mouseover="pauseHover = true" @mouseout="pauseHover = false" />
                <img v-else :src="playHover
                    ? '/static/new_icons/play-player-small_hover.svg'
                    : '/static/new_icons/play-player-small.svg'
                    " class="button" @click.stop.prevent="setPlay" id="play" @mouseover="playHover = true"
                    @mouseout="playHover = false" />
            </div>
        </div>
        <p id="date">{{ formatDate }}</p>
        <p id="artist">{{ item.artist }}</p>
        <p id="title">{{ item.title }}</p>
        <p id="venue">{{ item.venue }}</p>
        <p id="city">{{ item.city }}</p>

        <div class="function last">

            <img v-if="!store.authenticated" :src="likeHover ? '/static/Favorite_Hover.svg' : '/static/Favorite.svg'"
                @mouseover="likeHover = true" @mouseout="likeHover = false" class="button add"
                @click.prevent.stop="store.showLikePopup = true">
            <img v-else-if="store.likes.some(i => i == item.pk) || liked == true" @click.prevent.stop="removeLike"
                src="/static/Favorite_Hover.svg" @mouseout="likeHover = false" class="button add visible">
            <img v-else @click.prevent.stop="addLike"
                :src="likeHover ? '/static/Favorite_Hover.svg' : '/static/Favorite.svg'" @mouseover="likeHover = true"
                @mouseout="likeHover = false" class="button add">

            <img v-show="item.has_audio && !inPlaylist" :src="addHover
                ? '/static/new_icons/add_hover.svg'
                : '/static/new_icons/add.svg'
                " class="button" @click.stop.prevent="addToList" id="add" @mouseover="addHover = true"
                @mouseout="addHover = false" />
        </div>
    </router-link>
</template>

<script>
import { store } from "../store";
import { DateTime, Duration } from "luxon";
import axios from "axios";

export default {
    name: "ListElement",
    props: ["item", "live", "isPick", "onArchive", "isArchive", "first"],
    data() {
        return {
            store: store,
            addHover: false,
            playHover: false,
            pauseHover: false,
            liked: false,
            likeHover: false,
        };
    },
    computed: {
        formatDate() {
            return DateTime.fromISO(this.item.start_time)
                .setLocale("en-US")
                .toFormat("MM/dd/yy");
        },
        inPlaylist() {
            return this.store.playlist.items.some((e) => e.pk == this.item.pk);
        },
        itemIsPast() {

            if (this.item.timezone == '0' || this.item.timezone == null) {
                return true
            }
            let aware = DateTime.fromISO(this.item.start_time, {
                zone: this.item.timezone,
            });

            let utc = aware.toUTC();

            return utc.valueOf() < DateTime.utc().valueOf();

        },

        itemIsCurrentSeries() {
            if (this.item.all_series.length >= 1) {
                if (this.item.series.some(s => s.slug == this.item.all_series[0].slug)) {
                    if (this.itemIsPast) {
                        return true
                    } else {
                        return false
                    }
                } else if (this.item.series.some(s => s.slug == this.item.all_series[1].slug)) {
                    if (DateTime.fromISO(this.item.all_series[0].earliest_item) < DateTime.now()) {
                        return false
                    } else {
                        return true
                    }
                } else {
                    return false
                }

            } else {
                return false
            }
        },
    },
    methods: {
        addLike() {
            let myself = this;
            axios.defaults.headers.common["X-CSRFToken"] =
                myself.getCookie("csrftoken");
            axios
                .post("/api/add-like", {
                    pk: myself.item.pk,
                    user: myself.store.userID,
                })
                .then(function (response) {
                    if (response.data.message == "success") {
                        myself.liked = true
                        myself.store.likes.push(response.data.like)
                        localStorage.setItem("likes", JSON.stringify(myself.store.likes));
                        myself.liked = false
                    }

                })

        },
        removeLike() {
            let myself = this;
            axios.defaults.headers.common["X-CSRFToken"] =
                myself.getCookie("csrftoken");
            axios
                .post("/api/remove-like", {
                    pk: myself.item.pk,
                    user: myself.store.userID,
                })
                .then(function (response) {
                    if (response.data.message == "success") {
                        myself.liked = false
                        myself.store.likes = myself.store.likes.filter(l => l != response.data.like)
                        localStorage.setItem("likes", JSON.stringify(myself.store.likes));
                    }

                })

        },


        isPlaying(pk, type) {
            if (
                store.privatePlayerItem.type == type &&
                store.privatePlayerItem.pk == pk &&
                store.privatePlayerStatus == "playing"
            ) {
                return true;
            }
        },
        setPlay() {
            if (this.store.valid || this.isPick || this.itemIsCurrentSeries) {
                this.store.privatePlayerItem = this.item;
                this.store.privatePlayerVisible = true;
                this.store.privatePlayerChanged = true;
                // this.store.privatePlayerStatus = "paused";
                this.store.privatePlayerStatus = "unpaused";
            } else {
                this.store.showSupportPopup = true;
            }
            //let myself = this;
            //setTimeout(function(){
            //myself.store.privatePlayerStatus = 'startplaying';
            //}, 1000)
        },
        setPause() {
            this.store.privatePlayerStatus = "paused";
            this.pauseHover = false;
        },
        getCookie(cname) {
            var name = cname + "=";
            var decodedCookie = decodeURIComponent(document.cookie);
            var ca = decodedCookie.split(";");
            for (var i = 0; i < ca.length; i++) {
                var c = ca[i];
                while (c.charAt(0) == " ") {
                    c = c.substring(1);
                }
                if (c.indexOf(name) == 0) {
                    return c.substring(name.length, c.length);
                }
            }
            return "";
        },
        addToList() {
            let myself = this;
            axios.defaults.headers.common["X-CSRFToken"] =
                this.getCookie("csrftoken");
            axios
                .post("/api/add-task", {
                    //title: myself.item.title,
                    //artist: myself.item.artist,
                    //url: myself.item.audio,
                    //duration: myself.item.duration,
                    //thumbnail: myself.item.thumbnail,
                    //image: myself.item.image,
                    pk: myself.item.pk,
                    //category: myself.item.category,
                    //venue: myself.item.venue,
                    //city: myself.item.city,
                })
                .then(function (response) {
                    if (response.data.message == "success") {
                        myself.store.listFull = false;

                        axios.get("/api/get-tasks").then((response) => {
                            myself.store.playlist = response.data.playlist;
                            myself.store.streams = response.data.streams;
                        });
                    } else if (response.data.message == "listFull") {
                        myself.store.listFull = true;
                    }
                    myself.store.showAddPopup = true;
                });
        },
    },
};
</script>

<style scoped>
.element {
    display: flex;
    flex-direction: row;
    border-bottom: 1px solid black;
    align-items: center;
    width: 100%;
}

.element>p {
    padding: 0.65rem 1rem 0.65rem;
    margin: 0;
}

.LI:hover {
    background-color: #8dd9fc;
}

.IS:hover {
    background-color: #f6b2c6;
}

.IR:hover {
    background-color: #f6b2c6;
}

.RE:hover {
    background-color: #9fe1a7;
}

.NY:hover {
    background-color: #fcfac4;
}

.IN:hover {
    background-color: #B0A4E4;
}

#date {
    /*flex-basis: 5%;*/
    flex-basis: 5.6rem;
    font-variant-numeric: tabular-nums;
    font-feature-settings: "tnum" on, "case" on;
}

#artist {
    flex-basis: 30%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    flex-grow: 1;
    padding-left: 0;
}

#title {
    flex-basis: 30%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    flex-grow: 1;
    padding-left: 0;
}

#venue {
    flex-basis: 12%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    padding-left: 0;
}

#city {
    flex-basis: 12%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    padding-left: 0;
}

#functions {
    padding: 0.7rem 1rem 0.8rem;
    padding-left: 0;
    flex-basis: 4.7rem;
}

.function {
    flex-basis: 1.8rem;
    margin-right: 1rem;
    display: flex;
    gap: 4px;
    direction: rtl;
}

.function.last {
    flex-basis: 3.7rem;
}

.function:first-child {
    margin-right: 0rem;
    margin-left: 1rem;
}

.function>div {
    display: flex;
    align-items: center;
}

img {
    opacity: 0;
    transition: opacity 0.2s;
    width: 1.7rem;
}

#functions>img:nth-child(2) {
    margin-left: 0.5rem;
}

.element:hover img {
    opacity: 1;
}

.element img.visible {
    opacity: 1;
}
</style>
